// extracted by mini-css-extract-plugin
export default {"LeftPanel":"styles_LeftPanel__PUoQm"};